<template>
    <div class="chartbox">
        <div ref="chart" class="echart-container"></div>
    </div>
</template>

<script>


export default {
    name: 'LearnTimeChartView',
    props: {
        listDate:Array
    },
    watch:{
        listDate:function(nval,old){
            if(nval.length == 0){
                return
            }
            this.initChart()
        }
    },
    data() {
        return {
            //chartInstance: null, // 存储echarts实例
            resizeHandle: null
        }
    },
    mounted: function () {
        this.chartInstance = null;
        //this.initChart()
        this.resizeHandle = () => {
            this.handleResize();
        }
        // 兼容写法，监听窗口resize
        window.addEventListener('resize', this.resizeHandle);
        // 监听全局主题切换事件
        window.addEventListener('global-theme-changed', this.handleThemeChange);
    },
    beforeUnmount() {
        if (this.chartInstance) {
            this.chartInstance.dispose();
            this.chartInstance = null;
        }
        // 移除窗口resize事件监听
        window.removeEventListener('resize', this.resizeHandle);
        // 移除全局主题切换事件监听
        window.removeEventListener('global-theme-changed', this.handleThemeChange);
    },
    methods: {
        ///全局主题改变时调用
        handleThemeChange() {
            if (!this.chartInstance) {
                return
            }
            var option = this.getChartOption();
            this.chartInstance.setOption(option);
        },
        // 处理窗口resize事件
        handleResize() {
            if (this.chartInstance) {
                this.chartInstance.resize();
            }
        },
        // 初始化图表
        initChart() {
            const echarts = this.$echarts;
            const chartDom = this.$refs.chart;
            if (!chartDom) return;

            this.chartInstance = echarts.init(chartDom);

            var option = this.getChartOption();

            this.chartInstance.setOption(option);
        },
        ///获取配置选项
        getChartOption() {
            var textColor1 = getComputedStyle(document.documentElement).getPropertyValue('--ek-text-color1');
            var splitLineColor = getComputedStyle(document.documentElement).getPropertyValue('--ek-split-lineColor');
            
            var dates = []
            var learnTimes = []
            this.listDate.forEach(item => {
                dates.push(item.date)
                learnTimes.push(item.learnMinute)
            })

            const echarts = this.$echarts;
            var option = {
                title: {
                    text: '每日学习时长统计',
                    left: 'left',
                    textStyle: {
                        color: textColor1,
                    },
                },
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: ['学习时长（分钟）'],
                    top: 30,
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true,
                },
                toolbox: {
                    feature: {
                    },
                    right: 20,
                    top: 20,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: dates,
                    axisLabel: {
                        color: textColor1,  // 绿色
                        fontSize: 14,
                    }
                },
                yAxis: {
                    type: 'value',
                    min: 0,
                    splitLine: {
                        show: true,         // 是否显示分割线，默认为 true
                        lineStyle: {
                            color: splitLineColor,  // 颜色，比如灰色
                            width: 1,       // 线宽
                            type: 'solid'   // 线的类型，solid（实线）、dashed（虚线）、dotted（点线）
                        }
                    }
                },
                series: [
                    {
                        name: '学习时长（分钟）',
                        type: 'line',
                        data: learnTimes,

                        smooth: true,
                        lineStyle: {
                            width: 3,
                            // 渐变线条颜色，从蓝色过渡到紫色
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                { offset: 0, color: '#4F77FE' },
                                { offset: 1, color: '#7289FF' },
                            ]),
                            shadowColor: 'rgba(64, 158, 255, 0.5)',
                            shadowBlur: 10,
                            shadowOffsetY: 5,
                        },
                        itemStyle: {
                            color: '#4facfe', // 点的颜色
                            borderColor: '#fff',
                            borderWidth: 2,
                            shadowColor: 'rgba(31, 92, 238, 0.7)',
                            shadowBlur: 8,
                        },
                        areaStyle: {
                            // 渐变填充色，制造柔和背景
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#4F77FE' },
                                { offset: 1, color: '#7289FF64' },
                            ]),
                        },
                    },
                ],
            };
            return option;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 新增echarts图表容器样式，必须指定宽高 */
.echart-container {

    height: 400px;
    margin: 10px;


}

.chartbox {
    background: var(--ek-card-color1);
    border-radius: 10px;
    margin-top: 20px;
}
</style>
